var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconOfficialW = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon_official_w_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 7,
  r: 7,
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.508 10H8.221l-1.31-4.142L5.6 10H4.314L2.559 4.349h1.275l1.193 4.107 1.346-4.107h1.076l1.346 4.107 1.193-4.107h1.275z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon_official_w_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})))));
export default SvgIconOfficialW;